import {defineStore} from "pinia";
import {ref} from "vue";
import {useFetch} from "@vueuse/core";
import {BASE_URI} from "@/assets/const";
// import VueCookies from 'vue-cookies'



export const directionsStore = defineStore('directionsStore', () => {

    const isPending = ref(false)
    const directions = ref()

    const getDirections = async (name) => {
        // VueCookies.set('token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJodHRwOi8vMC4wLjAuMDo4MDgwL2FwaS8qKiIsImlzcyI6Imh0dHA6Ly8wLjAuMC4wOjgwODAvIiwidXNlcm5hbWUiOiJhZG1pbiIsImV4cCI6MTcxNjc3NTE5N30.5OrQaSfZTvHJP0EoU5DZe3voLoi7DElW0RT8lFKqFW0', '7d');
        isPending.value = true;
        // const token = VueCookies.get('token');
        const { error, data } = await useFetch(BASE_URI + "/api/view/directions?query="+name,{
            method: 'GET',
            // headers: {
            //     'Authorization': `Bearer ${token}`,
            // },
        }).get().json();
            
        if (error.value) {
            console.log(error.value)
            isPending.value = false;
            return error.value;
        } else {
            directions.value = data.value;
            console.log(directions.value)
        }
        isPending.value = false;
    }

    return{
        isPending,
        getDirections,
        directions
    }

})